export const SET_YANDEX_DATA_REQUEST = "SET_YANDEX_DATA_REQUEST"
export const SET_YANDEX_DATA_SUCCESS = "SET_YANDEX_DATA_SUCCESS"
export const SET_YANDEX_DATA_FAILED = "SET_YANDEX_DATA_FAILED"

export const GET_YANDEX_DATA_REQUEST = "GET_YANDEX_DATA_REQUEST"
export const GET_YANDEX_DATA_SUCCESS = "GET_YANDEX_DATA_SUCCESS"
export const GET_YANDEX_DATA_FAILED = "GET_YANDEX_DATA_FAILED"

export const ADD_NEW_YANDEX_REQUEST = "ADD_NEW_YANDEX_REQUEST"
export const ADD_NEW_YANDEX_SUCCESS = "ADD_NEW_YANDEX_SUCCESS"
export const ADD_NEW_YANDEX_FAILED = "ADD_NEW_YANDEX_FAILED"

export const ADD_NEW_YANDEX_CSV_REQUEST = "ADD_NEW_YANDEX_CSV_REQUEST"
export const ADD_NEW_YANDEX_CSV_SUCCESS = "ADD_NEW_YANDEX_CSV_SUCCESS"
export const ADD_NEW_YANDEX_CSV_FAILED = "ADD_NEW_YANDEX_CSV_FAILED"



export const addNewYandex = (data: any)=>{
    return{type:ADD_NEW_YANDEX_REQUEST,payload:{data}}
}

export const SetYandexData = (data:any)=>{
    return{
        type:SET_YANDEX_DATA_REQUEST,payload: {data}
    }
}

export const GetYandexData = ()=>{
    return{
        type:GET_YANDEX_DATA_REQUEST
    }
}

export const addNewYandexCSV = (data: any)=>{
    return{type:ADD_NEW_YANDEX_CSV_REQUEST,payload:data}
}
